<section class="profile-page">

  <!-- Header -->
  <header class="profile-header">
    <div class="profile-header__title">
      <span class="profile-header__icon"><mat-icon fontIcon="account_circle"></mat-icon></span>
      <div>
        <h1>Profile</h1>
        <p class="profile-header__subtitle">Your account details and registration information</p>
      </div>
    </div>
    <button mat-stroked-button color="primary" class="profile-header__action" (click)="showChangePasswod()">
      <mat-icon>lock_reset</mat-icon> Change password
    </button>
  </header>

  <!-- Account stat strip -->
  <div class="stat-strip">
    <div class="stat">
      <span class="stat__icon"><mat-icon fontIcon="fingerprint"></mat-icon></span>
      <div class="stat__body">
        <span class="stat__label">Customer ID</span>
        <span class="stat__value">{{ customerId }}</span>
      </div>
    </div>

    <div class="stat">
      <span class="stat__icon"><mat-icon fontIcon="verified_user"></mat-icon></span>
      <div class="stat__body">
        <span class="stat__label">Status</span>
        <span class="status-pill" [class.status-pill--active]="(status || '').toUpperCase() === 'ACTIVE'">
          <span class="status-pill__dot"></span>{{ status || '—' }}
        </span>
      </div>
    </div>

    <div class="stat">
      <span class="stat__icon"><mat-icon fontIcon="person"></mat-icon></span>
      <div class="stat__body">
        <span class="stat__label">User type</span>
        <span class="stat__value">{{ type || '—' }}</span>
      </div>
    </div>

    <div class="stat">
      <span class="stat__icon"><mat-icon fontIcon="event"></mat-icon></span>
      <div class="stat__body">
        <span class="stat__label">Creation date</span>
        <span class="stat__value">{{ (createdAt | date: 'MMM d, yyyy') || '—' }}</span>
      </div>
    </div>

    <div class="stat">
      <span class="stat__icon"><mat-icon fontIcon="home_work"></mat-icon></span>
      <div class="stat__body">
        <span class="stat__label">Active properties</span>
        <span class="stat__value">{{ totalProperties }}</span>
      </div>
    </div>
  </div>

  <!-- Account-type specific detail -->
  <div class="profile-content">
    <app-indiviual-property-owner *ngIf="externalUser?.accountType == 1"
      [ownerAccount]="ownerAccount"></app-indiviual-property-owner>
    <app-property-mgmt-co *ngIf="externalUser?.accountType == 2"
      [data]="propertyMgmtCoData"></app-property-mgmt-co>
    <app-b-bhotel-motel *ngIf="externalUser?.accountType == 3"
      [data]="individualBedHotel"></app-b-bhotel-motel>
  </div>
</section>
